import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';
import { RootState } from '../store';

export const getHunts = createAsyncThunk('hunts/get', async () => {
    const response = await axios.get('hunts', { params: { teamId: 0 } });
    // console.log('getHunts', response);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const searchMiniUsers = createAsyncThunk('hunts/search-users', async ({ pattern }: { pattern: string }) => {
    const response = await axios.post('users/search', { pattern });
    return response.data.data ?? [];
});

export const getHuntInvites = createAsyncThunk('hunts/invites-get', async () => {
    const response = await axios.get('hunts/invites', { params: { teamId: 0 } });

    // console.log('getHuntInvites', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const cancelTeamHunts = createAsyncThunk(
    'hunts/cancel-team-hunts',
    async ({ id, userId }: { id: number; userId?: number }) => {
        const data: any = {};
        if (userId) {
            data.userId = userId;
        }
        const response = await axios.delete(`hunts/cancel/team/${id}`, { data });

        // console.log('cancelTeamHunts', response.data);
        if (response.status === 200 && typeof response.data === 'object') {
            return response.data;
        } else {
            throw 'error';
        }
    },
);

export const cancelHunt = createAsyncThunk('hunts/cancel-hunt', async ({ id }: { id: number }) => {
    const response = await axios.delete(`hunts/cancel/${id}`);

    // console.log('cancelHunt', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return { id };
    } else {
        return { id: 0 };
    }
});

export const deleteHuntUser = createAsyncThunk(
    'hunts/delete-hunt-user',
    async ({ id }: { id: number }, { getState }) => {
        const state = getState() as RootState;

        const huntId = state.hunt.activeHunt;

        const response = await axios.delete(`hunts/${huntId}/users/${id}`);

        // console.log('deleteHuntUser', response.data);
        if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
            return response.data.data;
        } else {
            throw 'error';
        }
    },
);

export const deleteHuntInvite = createAsyncThunk('hunts/delete-hunt-invite', async ({ id }: { id: number }) => {
    const response = await axios.delete(`hunts/invites/${id}`);

    // console.log('deleteHuntInvite', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const deleteHuntGuestInvite = createAsyncThunk(
    'hunts/delete-hunt-guest-invite',
    async ({ id }: { id: number }) => {
        const response = await axios.delete(`hunts/invites/guest/${id}`);

        // console.log('deleteHuntGuestInvite', response.data);
        if (response.status === 200 && typeof response.data === 'object') {
            return response.data;
        } else {
            throw 'error';
        }
    },
);

export const huntDeclineInvite = createAsyncThunk('hunts/decline-invite', async ({ id }: { id: number }) => {
    const response = await axios.put(`hunts/decline-invite/${id}`);

    // console.log('huntDeclineInvite', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return { id };
    } else {
        return { id: false };
    }
});

export const huntAcceptInvite = createAsyncThunk('hunts/accept-invite', async ({ id }: { id: number }) => {
    const response = await axios.put(`hunts/accept-invite/${id}`);

    // console.log('huntAcceptInvite', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return { id };
    } else {
        return { id: false };
    }
});

export const startHuntAction = createAsyncThunk('hunts/start', async ({ id }: { id: number }) => {
    const timestamp = new Date().toUTCString();
    const response = await axios.post(`hunts/start/${id}?timestamp=${timestamp}`);

    // console.log('startHuntAction', response.data);
    if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
        return response.data;
    } else {
        throw 'error';
    }
});

export const endHuntAction = createAsyncThunk('hunts/end', async ({ id }: { id: number }) => {
    const timestamp = new Date().toUTCString();

    const response = await axios.post(`hunts/end/${id}?timestamp=${timestamp}`);

    // console.log('endHuntAction', response.data);
    if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
        return response.data;
    } else {
        throw 'error';
    }
});

export const huntUpdate = createAsyncThunk('hunts/update', async ({ id, data }: { id: number; data: any }) => {
    const response = await axios.put(`hunts/${id}`, data);

    // console.log('huntUpdate', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const huntCreate = createAsyncThunk('hunts/create', async ({ data }: { data: any }) => {
    const response = await axios.post(`hunts`, data);

    // console.log('huntCreate', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const sendHuntInvite = createAsyncThunk(
    'hunts/send-invite',
    async ({ userId, huntId }: { userId: number; huntId: number }) => {
        const response = await axios.post(`hunts/send-invite/${userId}/${huntId}`);
        console.log('sendHuntInvite', response.data);

        return response;
    },
);

export const sendHuntGuestInvite = createAsyncThunk(
    'hunts/send-guest-invite',
    async ({ huntId, phone, email }: { huntId: number; phone: string; email: string }) => {
        const response = await axios.post(`hunts/send-guest-invite/${huntId}?email=${email}&phone?${phone}`);

        // console.log('sendHuntGuestInvite', response.data);

        return response;
    },
);

export const leaveHunt = createAsyncThunk('hunts/leave', async ({ id }: { id: number }) => {
    const response = await axios.put(`hunts/leave/${id}`);

    // console.log('leaveHunt', response.data);
    if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
        return response.data;
    } else {
        throw 'error';
    }
});

export const getHunters = createAsyncThunk('hunts/get-hunters', async (_, { getState }) => {
    const state = getState() as RootState;

    const huntId = state.hunt.activeHunt;
    if (!huntId) return;

    const response = await axios.get(`hunts/users/${huntId}`);

    // console.log('getHuntInvites', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getHuntDeclinedUsers = createAsyncThunk('hunts/get-declined', async (_, { getState }) => {
    const state = getState() as RootState;

    const huntId = state.hunt.activeHunt;
    if (!huntId) return;

    const response = await axios.get(`hunts/declined/${huntId}`);

    // console.log('getHuntDeclinedUsers', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getHuntPendingUsers = createAsyncThunk('hunts/get-pending', async (_, { getState }) => {
    const state = getState() as RootState;

    const huntId = state.hunt.activeHunt;
    if (!huntId) return;

    const response = await axios.get(`hunts/pending/${huntId}`);

    // console.log('getHuntDeclinedUsers', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});
